/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormEvent, ReactNode, CSSProperties } from 'react';
import { cn } from 'styles';
import { cssToClasses, Gap } from '../styles';
import { AnyObject } from 'types';

type FlexCss = Pick<CSSProperties, 'alignItems' | 'justifyContent' | 'flexWrap' | 'position'> & {
  /**
   * Specifies the gap between elements.
   * Note:
   * - `1` corresponds to `4px` or `0.25rem` and so on.
   * - If passed a number, indicates the amount of pixels exactly. it will be converted to rem.
   */
  gap?: Gap;
};

export type ContainerOptions = 'header' | 'div' | 'article' | 'footer' | 'main' | 'form';

type ContainerProps<As extends ContainerOptions> = As extends 'form'
  ? { onSubmit?: (e: FormEvent) => any; as: As }
  : { onSubmit?: never; as?: As };

export type RowColumnProps<As extends ContainerOptions = 'div'> = FlexCss &
  ContainerProps<As> & {
    children: ReactNode;

    className?: string;
    title?: string;

    inLine?: boolean;
    fullWidth?: boolean;
    fullHeight?: boolean;
    relative?: boolean;

    /**
     * Use this if you want to control dynamic values
     */
    styles?: CSSProperties;

    // containerRef?: RefObject<HTMLDivElement> | ((node: HTMLDivElement | null) => void);
  };

export function resolveClasses({
  fullHeight,
  fullWidth,
  inLine,
  relative,
  className,
  ...props
}: Pick<
  RowColumnProps,
  | 'alignItems'
  | 'className'
  | 'flexWrap'
  | 'fullHeight'
  | `fullWidth`
  | `inLine`
  | 'justifyContent'
  | 'position'
  | 'relative'
  | 'fullWidth'
  | 'gap'
  | 'inLine'
>) {
  const classes = cssToClasses as Record<string, AnyObject>;

  const configClasses = Object.entries(props)
    .map(([prop, value]) => (typeof value === 'string' ? classes[prop]?.[value] : []))
    .flat();

  return cn(
    {
      'w-full': fullWidth,
      'h-full': fullHeight,
      relative,
    },
    inLine ? 'inline-flex' : 'flex',
    ...configClasses,
    className,
  );
}
